import { z } from "zod";

import { BulkChangeStatusSchema } from "./bulk-change-status";

/**
 * "Add to Blacklist" from the list table or the Messages lead panel (PREC-4435). The API resolves
 * the selection — ids, or a select-all from the same filters the table used to fetch its rows —
 * writes every lead's blacklist entry (and each company once with `addCompany`) and moves the
 * leads to Blacklist once. Build it with `buildBulkBlacklistRequest`.
 */
export const BulkBlacklistSchema = BulkChangeStatusSchema.pick({
	listId: true,
	assign: true,
	selectType: true,
	oldAssignStatus: true,
	inclusionFilterStatus: true,
	exclusionReasons: true,
	filter: true,
	priorityFilterStatus: true,
	signalFilterStatus: true,
	searchValue: true,
	assignStatuses: true,
}).extend({
	addCompany: z.boolean().optional(),
});

/** How many leads were moved to Blacklist and how many entries were written. */
export const BulkBlacklistResultSchema = z.object({
	leads: z.number(),
	entries: z.number(),
});

export type BulkBlacklist = z.infer<typeof BulkBlacklistSchema>;

export type BulkBlacklistResult = z.infer<typeof BulkBlacklistResultSchema>;
